import React from 'react';
import { Button } from '@ditioas/web-ui';
import { useTranslation } from 'react-i18next';

import cn from 'libs/cn';

interface ErrorScreenProps {
  heading?: string;
  description?: string;
  reportSent?: boolean;
  fullscreen?: boolean;
}

const ErrorScreen = ({
  heading,
  description,
  reportSent = false,
  fullscreen = false,
}: ErrorScreenProps) => {
  const { t } = useTranslation();
  let descriptionElement: React.ReactNode = null;

  if (!description) {
    descriptionElement = (
      <>
        <p>
          {!reportSent
            ? t('T.Sending_report')
            : t('T.Report_sent_Please_try_to_reload')}
        </p>
        <Button
          size="md"
          className={cn(
            'animate-in slide-in-from-bottom-8 fade-in duration-150',
            !reportSent && 'hidden'
          )}
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('Btn.Restart_app')}
        </Button>
      </>
    );
  } else {
    descriptionElement = <p>{description}</p>;
  }

  return (
    <section
      id="error-screen"
      className={cn(
        'px-8 py-12',
        fullscreen && 'fixed inset-0 z-50 items-center bg-white'
      )}
    >
      <div
        className={cn(
          'mx-auto flex max-w-80 flex-col gap-4 text-center',
          fullscreen && 'shadow-even p-16'
        )}
      >
        <h1 className="heading-lg">
          {heading !== null ? heading : t('Title.Module_crashed')}
        </h1>
        {descriptionElement}
      </div>
    </section>
  );
};

export default ErrorScreen;
